module.exports = __webpack_public_path__ + "static/media/image-slideshow-background.f0ff43d0.jpg";